import { createImageUrl } from '@nrk/serum-imagecrop-utils'

export const supportedWidths = [320, 450, 650, 768, 900, 1280, 1600, 1920, 2400]

export function createSrcSet(imageId, ratio, supportedWidths) {
  return supportedWidths
    .map(width => {
      const imageUrl = createImageUrl({ id: imageId, width, ratio, quality: 0.7 })
      return `${imageUrl} ${width}w`
    })
    .join(', ')
}

export function prepareUrl(url, ratio, width) {
  return url.replace('{{ratio}}', ratio).replace('{{width}}', width)
}

export function getPolopolyImageElement(
  polopolyId: string,
  alignmentClasses: string = '',
  imgStyle: string = '',
  pictureStyle: string = ''
): string {
  // const defaultUrl = createImageUrl({ id: polopolyId, width: 1600, ratio: '1:1', quality: 0.7 })
  // const desktopSourceSet = createSrcSet(polopolyId, '1:1', supportedWidths)
  const defaultUrl = createImageUrl({
    id: polopolyId,
    width: 1600,
    ratio: '16:9',
    quality: 0.7
  })
  const desktopSourceSet = createSrcSet(polopolyId, '16:9', supportedWidths)

  const mobileSourceSet = createSrcSet(polopolyId, '3:4', supportedWidths)

  return `
    <picture style="${pictureStyle}">
      <source media="(min-aspect-ratio: 3/4)" srcset="${desktopSourceSet}">
      <img src="${defaultUrl}" srcset="${mobileSourceSet}" class="${
    alignmentClasses
  }" style="${imgStyle}">
    </picture>`
}

export function getImageElement(imageUrl: string, alignmentClasses: string = ''): string {
  const imgStyle = 'min-width: 100%; min-height: 100%; position: relative;'
  return `<img src="${imageUrl}" class="${alignmentClasses}" style="${imgStyle}">`
}



// WEBPACK FOOTER //
// ./src/shared/utils/imageUtils.js